import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class SftpConnectionsApi {
  static getSftpConnections = (organizationId, params = {}) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections`,
      { params },
    );
  };

  static getSftpConnectionsForForm = () => {
    return axios.get(`${API_BASE_URL}/organizations/sftp-connections/form`);
  };

  static getSftpConnection = (organizationId, connectionId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections/${connectionId}`,
    );
  };

  static createSftpConnection = (organizationId, data) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections`,
      data,
    );
  };

  static updateSftpConnection = (organizationId, connectionId, data) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections/${connectionId}`,
      data,
    );
  };

  static deleteSftpConnection = (organizationId, connectionId) => {
    return axios.delete(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections/${connectionId}`,
    );
  };

  static getFileImport = (organizationId, connectionId, importId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections/${connectionId}/imports/${importId}`,
    );
  };

  static downloadFileImportSourceFile = (
    organizationId,
    connectionId,
    importId,
  ) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/sftp-connections/${connectionId}/imports/${importId}/source-file`,
      { responseType: 'blob' },
    );
  };
}
